import React, { useEffect } from 'react';
import type { FC } from 'react';
import { makeStyles } from '@material-ui/core';
import NProgress from 'nprogress';

import type { Theme } from 'src/ThemeComponents/theme';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    alignItems: 'center',
    backgroundColor: theme.palette.background.default,
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    justifyContent: 'center',
    minHeight: '100%',
    padding: theme.spacing(3)
  }
}));

const PageLoad: FC = () => {
  const classes = useStyles();

  useEffect(() => {
    NProgress.start();

    return () => {
      NProgress.done();
    };
  }, []);

  return (
    <div className={classes.root}>
       <img src='/static/images/preloader.gif' alt='loading...' />
    </div>
  );
};

export { PageLoad };
